
	frappe.templates['navbar'] = `<div class="sticky-top">
	{% if (!navbar_settings.dismissible_announcement_widget || !localStorage.getItem("dismissed_announcement_widget")) && strip_html(navbar_settings.announcement_widget) != '' %}
	<div class="announcement-widget form-message p-2 m-0" style="position: relative; z-index: -1; border-radius: 0; background-color: {{ navbar_settings.announcement_widget_color || 'var(--bg-blue)' }};">
		<div class="container flex justify-between align-center mx-auto">
			{{ navbar_settings.announcement_widget }}
			{% if navbar_settings.dismissible_announcement_widget %}
			<div class="close-message p-0 mr-2" style="position: relative;">
			{{ frappe.utils.icon("x") }}
			</div>
			{% endif %}
		</div>
	</div>
	{% endif %}

</div>
`;
